import React from 'react'
import LinkItem from './LinkItem'

const Links = ({ items }) => {
    return (
        <div className="top-menu">
            <ul>
                {items.map((item, i) => (
                    <LinkItem key={`link-${i}`} item={item} />
                ))}
            </ul>
        </div>
    )
}

export default Links